import { TrainingSelectorDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { BaseTrainingSelectorDrawer, TrainingSelectorFilterOptions } from "views/lms/training/drawers/BaseTrainingSelectorDrawer";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    title?: string;
    subtitle?: string;
    userId: string;
    multi?: boolean;
    onClose: (trainings: TrainingSelectorDto[] | undefined) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const TrainingSelectorDrawer: React.FC<IProps> = (props) => {
    const api = useCoreApi();

    const handleGetdata = ({ signal, ...filter }: TrainingSelectorFilterOptions) => {
        return api.v1.devPlan.trainingSelector({
            ...filter,
            userId: props.userId,
        }, { signal: signal });
    };

    return <BaseTrainingSelectorDrawer
        onGetData={handleGetdata}
        {...props}
    />;
};
